<div class="prompts-container">
    <div class="page-header">
        <div class="header-left">
            <h2 class="page-title">Prompt Management (Gemini 3.5)</h2>
            <div class="version-badge" *ngIf="promptData">
                <mat-icon>history</mat-icon>
                <span>Version: <strong>{{ promptData.version }}</strong></span>
            </div>
        </div>
        <div class="header-actions">
            <button mat-flat-button color="primary" (click)="savePrompt()"
                [disabled]="loading || saving || !promptData">
                <mat-icon>save</mat-icon>
                {{ saving ? 'Saving...' : 'Save Changes' }}
            </button>
        </div>
    </div>

    <div class="loading-shade" *ngIf="loading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div class="editors-grid" *ngIf="promptData">
        <div class="editor-card system-prompt">
            <div class="card-header">
                <div class="header-title">
                    <mat-icon>memory</mat-icon>
                    <h3>Cached Context Prompt (System)</h3>
                </div>
            </div>
            <div class="card-desc">
                DBにキャッシュされるベースの命令と事例集です。<code>{{ '{' + '{examples_text}' + '}' }}</code>にExcelデータが挿入されます。
            </div>
            <mat-form-field appearance="outline" class="full-width-textarea">
                <textarea matInput [(ngModel)]="promptData!.cached_context_prompt" rows="25"
                    spellcheck="false"></textarea>
            </mat-form-field>
        </div>

        <div class="editor-card user-prompt">
            <div class="card-header">
                <div class="header-title">
                    <mat-icon>person</mat-icon>
                    <h3>User Prompt (Request)</h3>
                </div>
            </div>
            <div class="card-desc">
                 リクエストごとに送信される指示です。<code>{{ '{' + '{target_text}' + '}' }}</code>に分析対象のテキストが挿入されます。
            </div>
            <mat-form-field appearance="outline" class="full-width-textarea">
                <textarea matInput [(ngModel)]="promptData!.user_prompt" rows="25" spellcheck="false"></textarea>
            </mat-form-field>
        </div>
    </div>
</div>